import { parseScene } from "@/utils/parseScene";

// What a canvas scene already says about the order's add-ons:
//   - engraving: every `text` entity; its words live in `name` ("New text" is the
//     canvas default but still a real, engraved text);
//   - keep the background: the photo entity is left unmasked (`mask.type: "none"`),
//     whereas "automatic" means the canvas cut the background away.
// The order form has two inscription lines, so the first line of text goes on the first
// and everything after it on the second, rather than being lost.
export const orderOptionsFromScene = (rawScene) => {
  const entities = parseScene(rawScene)?.entities || [];

  const lines = entities
    .filter((entity) => entity.type === "text")
    .flatMap((entity) => String(entity.name || "").split("\n"))
    .map((line) => line.trim())
    .filter(Boolean);

  const background = entities.some(
    (entity) => entity.type !== "text" && entity.mask?.type === "none"
  );

  return {
    inscriptionFirst: lines[0] || null,
    inscriptionSecond: lines.slice(1).join(" ") || null,
    background,
  };
};
